<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<!-- 발생일자 -->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001032') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<el-col :span="3">
					<!-- 품번 -->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
				<el-col :span="3">
					<!-- 발생공정 -->
					<select-combo
						:label="getMessage_('QWCC001030')"
						paramKey="powCd"
						:options="powCdList"
						:propData="searchParams.powCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<!-- 작성자 -->
					<search-input
						:label="getMessage_('MWCC000848')"
						paramKey="rgnNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.rgnNm"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="() => onUserPopup('rgn')"></i></template>
					</search-input>
				</el-col>
				<el-col :span="3">
					<!-- 발생공정 -->
					<select-combo
						:label="getMessage_('QWCC001700')"
						paramKey="badClCd"
						:options="badClCdList"
						:propData="searchParams.badClCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<!-- 발생공정 -->
					<select-combo
						:label="getMessage_('QWCC001033')"
						paramKey="badScnCd"
						:options="badScnCdList"
						:propData="searchParams.badScnCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC002079')"
						paramKey="serialNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.serialNo"
					>
					</search-input>
				</el-col>
			</el-row>

			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- popup -->
		<part-mng-popup ref="partMngPopup" @SendData="sendPartData" :scrId="scrId"></part-mng-popup>
		<user-popup-view ref="userPopupView" @SendData="sendUserData" :scrId="scrId" />
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { searchDateRange: [] };
	},
	components: { SelectCombo, SearchInput, PartMngPopup, UserPopupView },
	async created() {
		this.searchDateRange = [...this.getSearchDates_];
		await this.searchList();
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			if (param.key === 'rgnNm') {
				this.setSearchParam_({ key: 'rgnId', value: '' });
			}
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isPqyUser) {
					throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				}
				await this.getList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		// 부품 팝업용 메서드
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		sendPartData({ partNo }) {
			this.setSearchParam_({ key: 'partNo', value: partNo });
		},
		// 유저 팝업용 메서드
		onUserPopup(userGbn) {
			this.$refs.userPopupView.open({ userGbn, userName: this.searchParams[userGbn + 'Nm'] });
		},
		sendUserData(userData, userGbn) {
			this.setSearchParam_({ key: userGbn + 'Id', value: userData.userId });
			this.setSearchParam_({ key: userGbn + 'Nm', value: userData.userName });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
